import membersService from "@services/members.service";
import sessionService from "@services/session.service";

import { useState, createContext, useEffect } from "react";

export const UploadContext = createContext<any>({});

const UploadContextProvider = ({ children }: any) => {
  const [fileList, setFileList] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUpload, setIsUpload] = useState(false);
  const [message, setMessage] = useState("");
  const [spinLoader, setSpinLoader] = useState(false);
  const [freeText, setFreeText] = useState("");
  const [errorMessage, setErrorMessage] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [islogout, setIsLogout] = useState(false);
  const [strValidation, setStrValidation] = useState(false)

  const onUpload = (event: any) => {


    if (fileList.length > 0 && !strValidation && freeText.length>=3 && freeText.length<=15) {
      setMessage(" Uploading...");
      setIsUpload(true);
      setSpinLoader(true);
      const data = new FormData();

      const clientName: any = sessionService.getClient()?.clientName;


      for (let i = 0; i < fileList.length; i++) {
        data.append("file", fileList[i]);
      }
      data.append("clientName", clientName);
      data.append("clientNote", freeText);

      const config = {
        onUploadProgress: (progressEvent: any) => {
          let uploadPercentage = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          if (uploadPercentage < 90) {
            setUploadProgress(uploadPercentage);
          } else {
            setUploadProgress(90);
          }
        },
      };

      membersService.uploadFile(data, config).subscribe({
        next: (res) => {
          setMessage("Files Uploaded succesfully");
          setUploadSuccess(true);
          setSpinLoader(false);
          setIsUpload(false);
          setFileList([]);
          setFreeText("");
          setTimeout(() => {
            setMessage("");
            setUploadSuccess(false);
          }, 6000);
        },
        error: (err) => {
          setMessage("Something went wrong please try again...!");
          setUploadSuccess(true);
          setSpinLoader(false);
          setIsUpload(false);
          setFileList([]);
          setFreeText("");
          setTimeout(() => {
            setMessage("");
            setUploadSuccess(false);
          }, 6000);
        },
      });
    } else {
      errorMessage
        ? setMessage("Required field")
        : setMessage("Please Select Files to upload");
      setUploadSuccess(true);
      setErrorMessage(true);
      setTimeout(() => {
        setMessage("");
        setUploadSuccess(false);
        // setErrorMessage(false);
      }, 3000);
      setIsLogout(false);
    }
  };

  useEffect(() => {
    console.log("UploadContextProvider.useEffect1");
    setUploadProgress(100);
  }, [uploadSuccess]);

  const props = {
    beforeUpload: (currentFile: any, files: any) => {
      if (fileList.length > 0) {
        let currentFileList = fileList;
        setFileList(currentFileList.concat(files));
      } else {
        setFileList(files);
      }
      setMessage("");
      setErrorMessage(true);
      return false;
    },
    multiple: true,
    onRemove: (removedFile: any) => {
      setFileList(
        fileList.filter(
          (fileInTheList: any) => fileInTheList.uid !== removedFile.uid
        )
      );
    },
    showUploadList: false,
  };

  const onRemoveFile = (fileId: any) => {
    setFileList(
      fileList.filter((fileInTheList: any) => fileInTheList.uid !== fileId)
    );
  };

  const validateText = (text:any) =>{
    const regex = new RegExp("^[a-zA-Z0-9-]+$");

    if (text.length > 15 || text.length < 3) {
      text.length === 0
        ? setMessage("Required field")
        : setMessage("Charater length should be between 3 to 15");
        setStrValidation(true);
    } else if (!regex.test(text)) {
      setStrValidation(true);
      setMessage("No special characters allowed.!");
    } else {
      setFreeText(text.toLowerCase());
      setMessage("");
      setStrValidation(false);
    }
  }

  const onChangeNote = (e: any) => {
    let note = e.target.value;
    validateText(note)
  };

  const value = {
    onChangeNote,
    errorMessage,
    message,
    fileList,
    props,
    isUpload,
    onRemoveFile,
    onUpload,
    uploadProgress,
    spinLoader,
    uploadSuccess,
    setIsLogout,strValidation,freeText
  };

  if (isUpload) {
    window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();
      return (ev.returnValue = "");
    });
  }

  useEffect(() => {
    console.log("UploadContextProvider.useEffect2");
    if (islogout) {
      window.alert("Files are being Uploaded Please Wait......!");
      setIsLogout(false)
    }
  }, [islogout]);

  return (
    <UploadContext.Provider value={value}>{children}</UploadContext.Provider>
  );
};

export default UploadContextProvider;
